export default __webpack_public_path__ + "static/media/ibBTC.46ae169c.svg";